import { useEffect, useState } from 'react';

import { lightTheme } from '../theme/Themes';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    let rafId: number | null = null;

    function handleResize() {
      // Resize can fire extremely frequently while dragging the window.
      // Coalesce updates to once per frame.
      if (rafId != null) {
        window.cancelAnimationFrame(rafId);
      }
      rafId = window.requestAnimationFrame(() => {
        rafId = null;
        const next = getWindowDimensions();
        setWindowDimensions((prev) => (prev.width === next.width && prev.height === next.height ? prev : next));
      });
    }

    window.addEventListener('resize', handleResize);
    return () => {
      if (rafId != null) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
      }
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowDimensions;
}

export const parsePx = (px: string) => Number(px.replace('px', ''));

export const inMobile = (width?: number) =>
  (width || window.innerWidth) <= Number(parsePx(lightTheme.breakpoints.mobile));

export const inTablet = (width?: number) =>
  (width || window.innerWidth) <= Number(parsePx(lightTheme.breakpoints.tablet));

export const inDesktop = (width?: number) =>
  (width || window.innerWidth) > Number(parsePx(lightTheme.breakpoints.tablet));

// Layout breakpoints for standard padding
export const smallLayout = (width?: number) =>
  (width || window.innerWidth) < Number(parsePx(lightTheme.breakpoints.tablet));

export const mediumLayout = (width?: number) =>
  (width || window.innerWidth) >= Number(parsePx(lightTheme.breakpoints.tablet)) &&
  (width || window.innerWidth) < Number(parsePx(lightTheme.breakpoints.large));

export const largeLayout = (width?: number) =>
  (width || window.innerWidth) >= Number(parsePx(lightTheme.breakpoints.large));
